<template>
  <div :class="$style.wrapper">
    <div :class="$style.map">
      <div :class="[$style.pin, 'dropzone']" :data-pin="1"></div>
      <div :class="[$style.pin, 'dropzone']" :data-pin="2"></div>
      <div :class="[$style.pin, 'dropzone']" :data-pin="3"></div>
      <div :class="[$style.pin, 'dropzone']" :data-pin="4"></div>

      <div :class="[$style.pin, 'dropzone']" :data-pin="5"></div>
      <div :class="[$style.pin, 'dropzone']" :data-pin="6"></div>
      <div :class="[$style.pin, 'dropzone']" :data-pin="7"></div>
      <div :class="[$style.pin, 'dropzone']" :data-pin="8"></div>
    </div>
    <div :class="$style.users" v-if="!ready">
      <User
        v-for="user in users"
        :key="user.id"
        :user="user"
      />
    </div>
    <transition name="fade">
      <div :class="$style.container" v-if="ready">
        <Button :class="$style.button" @click="run">
          Посчитать результат
        </Button>
      </div>
    </transition>
  </div>
</template>
<script>
import User from '../User/User.vue'

import Button from '@/components/@ui/Button/Button.vue'

import Bus from '../../Bus'

export default {
  name: 'DragTable',
  props: {
    users: Array,
  },
  components: { User, Button },
  data: () => ({
    result: [[], []],
    ready: false,
  }),
  mounted() {
    const { Droppable } = require('@shopify/draggable')
    const container = this.$el

    this.draggable = new Droppable(container, {
      draggable: '.draggable',
      dropzone: '.dropzone',
      mirror: {
        constrainDimensions: true,
        appendTo: 'body',
      },
    })

    this.droppableOrigin = null
    this.sourceDropZone = null

    this.draggable.on('droppable:dropped', (evt) => {
      if (this.droppableOrigin !== evt.dropzone.dataset.zone && evt.dropzone.dataset.zone !== undefined) {
        evt.cancel()
      }
    })

    this.draggable.on('drag:start', (evt) => {
      const { source } = evt.data
      this.sourceDropZone = source.closest('.dropzone')
      this.droppableOrigin = source.dataset.id
    })

    const pins = [...document.querySelectorAll('[data-pin]')]

    const leftTable = pins.slice(0, 4)
    const rightTable = pins.slice(4, 8)

    this.draggable.on('drag:stop', () => {
      const itemsLeft = this.getIDsFromTable(leftTable)
      const itemsRight = this.getIDsFromTable(rightTable)

      this.result = [itemsLeft, itemsRight]

      this.ready = [...itemsLeft, ...itemsRight].length === 8
    })
  },
  beforeDestroy() {
    this.draggable.destroy()
  },
  methods: {
    getIDsFromTable(table) {
      return table
        .map(item => item.querySelector('.b-user'))
        .filter(Boolean)
        .map(item => parseInt(item.dataset.id, 10))
        .map(id => this.users.find(item => item.id === id))
    },
    calculateTable(table) {
      return table.reduce((acc, user, index) => {
        const nextUser = index === table.length - 1 ? table[0] : table[index + 1]
        if (nextUser.synergy.includes(user.id)) return acc + 1
        return acc
      }, 0)
    },
    run() {
      const [left, right] = this.result
      const leftResults = this.calculateTable(left)
      const rightResults = this.calculateTable(right)

      const result = leftResults + rightResults

      Bus.$emit('dragTableReady', result)
    },
  },
}
</script>
<style lang="scss" module>
@import './DragTable.scss';
</style>
